export enum LocationType {
  ParkingLot = 'ParkingLot',
  Garage = 'Garage',
  OnStreet = 'OnStreet',
}

export const LocationTypeLabels: Record<LocationType, string> = {
  [LocationType.ParkingLot]: 'Parking Lot',
  [LocationType.Garage]: 'Garage',
  [LocationType.OnStreet]: 'On-Street Parking',
};


export const LocationTypeOptions = Object.values(LocationType).map((type) => ({
  text: LocationTypeLabels[type],
  value: type,
}));
